import { createEmptyCollection, removeByKeyFromCollection, setItemInCollection } from 'helpers/normalizeHelpers'
import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import {
  CreateCCPaymentMethodAction,
  DeleteCCPaymentMethodAction,
  GetCCPaymentMethodsAction,
  SetCCPaymentMethodsAction,
} from 'components/features/creditCard/creditCardStore/actions'
import { CCPaymentMethod } from 'components/features/creditCard/creditCardStore/types'

const INITIAL_STATE = createEmptyCollection()
export const ccPaymentMethodsReducer: Reducer<CreditCardDataState['paymentMethods']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCPaymentMethodsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }

    case SetCCPaymentMethodsAction.type: {
      if (!action.payload) {
        return prevState
      }

      return action.payload
    }

    case CreateCCPaymentMethodAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return setItemInCollection<CCPaymentMethod, 'uid'>(prevState, action.payload.response, 'uid')
    }

    case DeleteCCPaymentMethodAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return removeByKeyFromCollection<CCPaymentMethod, 'uid'>(prevState, action.payload.params)
    }

  }

  return prevState
}
